var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.767 11.73V1.781C4.767.798 5.567 0 6.556 0H22.21C23.2 0 24 .798 24 1.781v9.95c0 .983-.8 1.78-1.789 1.78h-2.983v4.093l-4.563-4.092H6.556c-.99 0-1.79-.798-1.79-1.782zM1.789 3.911h2.238v8.691c0 .747.973 1.707 1.722 1.707.75 0 8.756.044 8.756.044 0 .984-.801 1.582-1.789 1.582H9.269L4.772 20l.005-4.065H1.79c-.99 0-1.789-.598-1.789-1.582v-8.71c0-.983.8-1.732 1.789-1.732z",
    fillRule: "nonzero"
  })));
}
export default SvgChat;